import React, { useState, useRef, ReactNode } from "react";
import {
  ChevronDown,
  ChevronUp,
  Globe,
  List,
  XLg,
} from "react-bootstrap-icons";
import { useRecoilState } from "recoil";
import { langState } from "./recoilAtom";
import Logo from "../components/logo";
import {
  Button,
  FieldError,
  Header as AriaHeader,
  Label,
  ListBox,
  ListBoxItem,
  Popover,
  Section,
  Select,
  SelectValue,
  Text,
} from "react-aria-components";
import { useHover } from "react-aria";
import { Link } from "gatsby";
import { ContentWrapper } from "./layout";
import Dropdownlink from "./dropdownLink/dropdownlink";
import { StaticImage } from "gatsby-plugin-image";
import EUflag from "../images/EUflag.jpg";
import DropdownlinkMobile from "./dropdownLink/dropdownlinkmobile";
import HamburgerButton from "./hamburgerbutton";

interface HeaderProps {
  className?: string;
}

interface linkItemProps {
  text: string | ReactNode;
  url: string;
  dropdown?: any;
}

interface linksDataProps {
  [lang: string]: linkItemProps[];
}

export const linksData: linksDataProps = {
  "pl-PL": [
    {
      text: "Dla specjalistów",
      url: "/products",
      dropdown: [
        {
          textDropdown: "PacePress",
          urlDropdown: "/products/pacepress",
        },
        {
          textDropdown: "CoolCryo",
          urlDropdown: "/products/coolcryo",
        },
        {
          textDropdown: "AtriClamp",
          urlDropdown: "/products/atriclamp",
        },
        {
          textDropdown: "MiniMax",
          urlDropdown: "/products/minimax",
        },
        {
          textDropdown: "EP Bioptom",
          urlDropdown: "/products/epbioptom",
        },
      ],
    },
    {
      text: "Strefa pacjenta",
      url: "/patients",
      dropdown: [
        {
          textDropdown: "Arytmia",
          urlDropdown: "/patients/arrhythmia",
        },
        {
          textDropdown: "Niewydolność serca",
          urlDropdown: "/patients/heartfailure",
        },
        {
          textDropdown: "Udar niedokrwienny",
          urlDropdown: "/patients/stroke",
        },
      ],
    },
    {
      text: "O Nas",
      url: "/about",
      dropdown: [
        {
          textDropdown: "Nasza firma",
          urlDropdown: "/our-company",
        },
        {
          textDropdown: "Władze spółki",
          urlDropdown: "/leadership",
        },
        {
          textDropdown: "Projekty UE",
          urlDropdown: "/grants",
        },
      ],
    },
    {
      text: "Media",
      url: "/media",
      dropdown: [
        {
          textDropdown: "Aktualności",
          urlDropdown: "/newsroom",
        },
        {
          textDropdown: "Wydarzenia",
          urlDropdown: "/events",
        },
        {
          textDropdown: "Materiały dla mediów",
          urlDropdown: "/media-gallery",
        },
      ],
    },
    {
      text: "Relacje inwestorskie",
      url: "/investors",
      dropdown: [
        {
          textDropdown: "Raporty giełdowe",
          urlDropdown: "/reports",
        },
        {
          textDropdown: "Zgromadzenia Akcjonariuszy",
          urlDropdown: "/general-meetings",
        },
        {
          textDropdown: "Dokumenty korporacyjne",
          urlDropdown: "/corporate-documents",
        },
      ],
    },
    {
      text: "Kontakt",
      url: "/contact",
    },
    {
      text: (
        <>
          {" "}
          <img
            src={EUflag}
            alt="EU flag"
            className="flex min-w-4 min-h-4 w-auto lg:h-full h-auto max-h-10 footer-flag rounded-md"
            style={{ marginLeft: "4px" }}
          />
        </>
      ),
      url: "/grants",
    },
  ],
  "en-US": [
    {
      text: "Healthcare Professionals",
      url: "/products",
      dropdown: [
        {
          textDropdown: "PacePress",
          urlDropdown: "/products/pacepress",
        },
        {
          textDropdown: "CoolCryo",
          urlDropdown: "/products/coolcryo",
        },
        {
          textDropdown: "AtriClamp",
          urlDropdown: "/products/atriclamp",
        },
        {
          textDropdown: "MiniMax",
          urlDropdown: "/products/minimax",
        },
        {
          textDropdown: "EP Bioptom",
          urlDropdown: "/products/epbioptom",
        },
      ],
    },
    {
      text: "Patients & Caregivers",
      url: "/patients",
      dropdown: [
        {
          textDropdown: "Arrhythmia",
          urlDropdown: "/patients/arrhythmia",
        },
        {
          textDropdown: "Heart failure",
          urlDropdown: "/patients/heartfailure",
        },
        {
          textDropdown: "Ischemic stroke",
          urlDropdown: "/patients/stroke",
        },
      ],
    },
    {
      text: "About Us",
      url: "/about",
      dropdown: [
        {
          textDropdown: "Our Company",
          urlDropdown: "/our-company",
        },
        {
          textDropdown: "Leadership",
          urlDropdown: "/leadership",
        },
        {
          textDropdown: "EU Projects",
          urlDropdown: "/grants",
        },
      ],
    },
    {
      text: "Media",
      url: "/media",
      dropdown: [
        {
          textDropdown: "Newsroom",
          urlDropdown: "/newsroom",
        },
        {
          textDropdown: "Events",
          urlDropdown: "/events",
        },
        {
          textDropdown: "Media gallery",
          urlDropdown: "/media-gallery",
        },
      ],
    },
    {
      text: "Investor Relations",
      url: "/investors",
      dropdown: [
        {
          textDropdown: "Stock Market Reports",
          urlDropdown: "/reports",
        },
        {
          textDropdown: "Shareholders' Meetings",
          urlDropdown: "/general-meetings",
        },
        {
          textDropdown: "Corporate Documents",
          urlDropdown: "/corporate-documents",
        },
      ],
    },

    {
      text: "Contact",
      url: "/contact",
    },
    {
      text: (
        <>
          {" "}
          <img
            src={EUflag}
            alt="EU flag"
            className="flex min-w-4 min-h-4 w-auto lg:h-full h-auto max-h-8 rounded-md footer-flag"
            style={{ marginLeft: "4px" }}
          />
        </>
      ),
      url: "/grants",
    },
  ],
};

const LangSwitcherData = [
  {
    langCode: "pl-PL",
    text: (
      <>
        <span className="font-bold"> Polski </span>
      </>
    ),
  },
  {
    langCode: "en-US",
    text: (
      <>
        <span className="font-bold"> English </span>
      </>
    ),
  },
];

const Header: React.FC<HeaderProps> = (props) => {
  const menuRef = useRef(null) as any;
  const [isMenuOpen, setMenuOpen] = useState(false);
  const [lang, setLang] = useRecoilState(langState);
  const [isHamburegerMenuOpen, setHamburgerMenuOpen] = useState(false);

  const closeLangMenu = (e: any) => {
    !menuRef.current?.contains(e.target) && setMenuOpen(false);
  };

  React.useEffect(() => {
    document.addEventListener("click", closeLangMenu);
  }, []);

  const { hoverProps, isHovered } = useHover(props as any);

  return (
    <header
      className={`${props.className} fixed top-0 left-0 w-full flex justify-center items-center z-50 bg-white shadow-xl h-[80px]`}
    >
      {isHamburegerMenuOpen === true ? (
        <div className="lg:hidden flex fixed top-0 left-0 w-full h-screen bg-white z-50 flex-col items-center justify-start">
          <div className="flex flex-row-reverse absolute top-0 left-0 w-full items-center justify-between px-6 py-4 border-b-2 border-solid border-gray-200">
            <span className="h-11 w-11"></span>
            <Link
              to="/"
              style={{ textDecoration: "none" }}
              onClick={() => setHamburgerMenuOpen(false)}
            >
              <Logo />
            </Link>
          </div>

          <ul className="w-full mt-30 px-6">
            {linksData[lang].map((linkItem, idx) => (
              <>
                <DropdownlinkMobile
                  isOpen={isHamburegerMenuOpen}
                  key={idx + "link-item"}
                  onClick={() => setHamburgerMenuOpen(false)}
                  onClickChildren={() => setHamburgerMenuOpen(false)}
                  linkItem={linkItem}
                />
              </>
            ))}
          </ul>

          <div className="hamburger-menu-language-selector flex justify-between items-center w-full px-6 py-4 border-t-2 border-solid border-gray-200">
            <Globe className="w-6 h-6" />
            <Select
              selectedKey={lang}
              onSelectionChange={(item: any) => {
                setLang(item);
                setHamburgerMenuOpen(false);
              }}
              className="flex gap-4 items-center border border-solid border-blue-600 rounded-md px-4 py-2"
            >
              <Button className="flex gap-4 items-center">
                <SelectValue />
                <span
                  aria-hidden="true"
                  style={{ transform: "rotate(180deg)" }}
                >
                  <ChevronUp className="w-4 h-4" />
                </span>
              </Button>
              <Popover className="flex flex-col gap-4 p-6 shadow-xl rounded-lg items-center justify-center">
                <ListBox
                  items={LangSwitcherData}
                  className="flex flex-col gap-4 text-base"
                >
                  {(item) => (
                    <ListBoxItem id={item.langCode}>{item.text}</ListBoxItem>
                  )}
                </ListBox>
              </Popover>
            </Select>
          </div>
        </div>
      ) : (
        ""
      )}

      <div className="flex max-w-[1400px] w-full max-h-[80px] justify-between items-center px-6 lg:px-0 h-full">
        <Link className="flex" to="/">
          <Logo />
        </Link>
        <ul className="hidden lg:flex gap-10 items-center group-wrapper">
          {linksData[lang].map((linkItem, idx) => (
            <>
              <Dropdownlink linkItem={linkItem} key={idx + "dropdown-link"} />
            </>
          ))}
        </ul>
        <div className="hamburger-menu-wrapper lg:hidden flex flex-row-reverse gap-4 items-center">
          <span className="h-11 w-11">
            <HamburgerButton
              isOpenState={isHamburegerMenuOpen}
              onClick={() => setHamburgerMenuOpen(!isHamburegerMenuOpen)}
              style={{ all: "unset" }}
            />
          </span>

          {/* <button
            onClick={() => setHamburgerMenuOpen(true)}
            style={{ all: "unset" }}
          >
            <List className="h-10 w-10" />
          </button> */}

          <div style={{ position: "relative" }} ref={menuRef}>
            {LangSwitcherData.map((item, idx) =>
              lang === item.langCode ? (
                <button
                  key={idx + "switcher"}
                  className="icon-button"
                  onClick={() => setLang(lang === "pl-PL" ? "en-US" : "pl-PL")}
                >
                  <Globe className="hidden lg:flex cursor-pointer" />

                  {lang === "pl-PL" ? "PL" : "EN"}
                </button>
              ) : null
            )}
          </div>
        </div>

        <div
          className="hidden lg:flex gap-2 items-center relative"
          ref={menuRef}
        >
          {LangSwitcherData.map((item, idx) =>
            lang === item.langCode ? (
              <button
                key={idx + "switcher2"}
                className="flex gap-2 items-center cursor-pointer"
                onClick={() => setMenuOpen(!isMenuOpen)}
              >
                <Globe className="hidden lg:flex w-6 h-6" />

                {lang === "pl-PL" ? "PL" : "EN"}
              </button>
            ) : null
          )}
          {isMenuOpen ? (
            <ul className="absolute top-8 right-0 bg-white shadow-xl rounded-lg z-50 flex flex-col w-max overflow-hidden">
              {LangSwitcherData.map((item, idx) => (
                <li
                  className="text-base hover:bg-blue-100 p-4 hover:text-blue-600 cursor-pointer"
                  key={idx + "switcher3"}
                  onClick={() => {
                    setLang(item.langCode);
                    setMenuOpen(false);
                  }}
                >
                  {item.text}
                </li>
              ))}
            </ul>
          ) : null}
        </div>
      </div>
    </header>
  );
};

export default Header;
